<app-auth-layout>
  <h2>Crear una cuenta</h2>
  <h6>Para ser parte de Dicea</h6>
  <br>
  <ngx-spinner bdColor="rgba(255,255,255,0.8)" name="spUsuarioCreate" size="default" color=" var(--primary-color)"
    type="ball-atom" [fullScreen]="false">
  </ngx-spinner>
  <div class="row">
    <div class="col">
      <form [formGroup]="usuarioForm">
        <div class="row">
          <div class="col-lg-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nombre</mat-label>
              <input matInput type="text" maxlength="50" formControlName="Nombre" />
              <mat-error *ngIf="usuarioForm.controls['Nombre'].hasError('required')">El nombre es
                <strong>requerido</strong>
              </mat-error>
              <mat-error *ngIf="usuarioForm.controls['Nombre'].hasError('maxlength')">Supero el maximo de
                caracteres.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-ls-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Apellido</mat-label>
              <input matInput type="text" maxlength="50" formControlName="Apellido" />
              <mat-error *ngIf="usuarioForm.controls['Apellido'].hasError('required')">El nombre es
                <strong>requerido</strong>
              </mat-error>
              <mat-error *ngIf="usuarioForm.controls['Apellido'].hasError('maxlength')">Supero el maximo de
                caracteres.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-ls-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Correo</mat-label>
              <input matInput type="email" maxlength="50" formControlName="Correo" />
              <mat-error *ngIf="usuarioForm.controls['Correo'].hasError('required')">El nombre es
                <strong>requerido</strong>
              </mat-error>
              <mat-error *ngIf="usuarioForm.controls['Correo'].hasError('maxlength')">Supero el maximo de
                caracteres.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-ls-12">
            <mat-form-field appearance="outline" class="w-100">
              <ngx-spinner name="spListadoPaises" bdColor="rgba(255,255,255,0.8)" size="default" color=" #1B3F3F"
                type="ball-atom" [fullScreen]="false">
              </ngx-spinner>

              <mat-label>Selecciona un país</mat-label>
              <input type="text" matInput formControlName="Pais" [matAutocomplete]="auto" />
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setSelectedCountry($event.option.value)">
                <mat-option *ngFor="let country of filteredCountries | async" [value]="country.name.common">
                  <img [src]="country.flags.svg" alt="Bandera de {{ country.name }}" width="24"
                    style="margin-right: 8px;">

                  <span class="country-name">{{ country.name?.common }}</span>
                  <span class="calling-code">
                    ({{ country.idd?.root }}{{ country.idd?.suffixes?.[0] || '' }})
                  </span>
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="usuarioForm.controls['Pais'].hasError('required')">El nombre es
                <strong>requerido</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-ls-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Telefono</mat-label>
              <input matInput type="tel" maxlength="50" formControlName="Telefono" />
              <mat-error *ngIf="usuarioForm.controls['Telefono'].hasError('required')">El nombre es
                <strong>requerido</strong>
              </mat-error>
              <mat-error *ngIf="usuarioForm.controls['Telefono'].hasError('maxlength')">Supero el maximo de
                caracteres.
              </mat-error>
              <mat-error *ngIf="usuarioForm.controls['Telefono'].hasError('pattern')">Formato de telefono
                invalido.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-ls-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Clave nueva</mat-label>
              <input matInput [type]="hide ? 'password' : 'text'" maxlength="150" formControlName="ClaveNueva" />

              <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide" class="no-ripple-button">
                <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
              </button>

              <!-- <button mat-icon-button matSuffix class="no-ripple-button" disabled="true"
                    [matTooltip]="passwordStrength?.strength || 'Seguridad desconocida'"
                    [ngClass]="passwordStrength?.class || ''">

                    <mat-icon *ngIf="passwordStrength?.class; else defaultIcon"
                      [ngClass]="passwordStrength?.class">shield</mat-icon>

                  </button> -->

              <ng-template #defaultIcon>
                <mat-icon class="shield-default">shield</mat-icon>
              </ng-template>

              <mat-error *ngIf="usuarioForm.controls['ClaveNueva'].hasError('required')">
                Ingrese <strong>clave nueva.</strong>
              </mat-error>
              <mat-error *ngIf="usuarioForm.controls['ClaveNueva'].hasError('minlength')">
                Debe superar los 8 caracteres.
              </mat-error>
              <mat-error *ngIf="usuarioForm.controls['ClaveNueva'].hasError('maxlength')">
                Superó el máximo de caracteres.
              </mat-error>

              <!-- <mat-error matTooltip="La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una minúscula, un número y un carácter especial." *ngIf="usuarioForm.controls['ClaveNueva'].hasError('pattern')">
                    La clave con cumple con las politicas.
                  </mat-error> -->

              <!-- <button matSuffix mat-icon-button color="primary" (click)="generarClaveAleatoria()" aria-label="Generar clave aleatoria" #tooltip="matTooltip" matTooltip="Genera clave aleatoria.">
        <mat-icon>autorenew</mat-icon>
      </button> -->
            </mat-form-field>

          </div>
        </div>
      </form>
    </div>
  </div>
  <button mat-raised-button color="primary" type="submit" class="w-100" name="Guardar" [disabled]="!usuarioForm.valid"
    (click)="onSubmit()" value="Guardar">
    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    Registrate
  </button>
  <br><br>
   <span>¿Ya tenés una cuenta? </span>
    <button mat-button color="accent" [routerLink]="['/login']">Iniciar Sesión</button>

</app-auth-layout>
